var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2892,6623.333c.267.379,2.964,3.01,3.529,3.57,1.188,1.189,2.338,2.34,3.525,3.533,1.338,1.334,20.93,21.047,21.37,21.278l28.339-28.358c-.25-.483-5.558-5.638-6.2-6.287a22.036,22.036,0,0,0-2.154-2.069,6.118,6.118,0,0,0-.879.922,27.038,27.038,0,0,1-30.968,5.365,26.491,26.491,0,0,1-6.431-4.385,11.426,11.426,0,0,1-1.8-1.857c-.4.165-5.495,5.387-6.264,6.142A23.3,23.3,0,0,0,2892,6623.333Z",
    transform: "translate(-2860.382 -6531.715)",
    fill: "#0fa9a6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2891,2655.36c.44.562,8.19,8.269,8.437,8.394l19.9-19.9,19.966,19.9c.394-.23,5.554-5.469,6.326-6.266a15.364,15.364,0,0,0,2.133-2.234,22.5,22.5,0,0,1-1.779-1.713l-10.607-10.609c-.586-.6-1.231-1.169-1.816-1.752-.27-.27-13.871-13.973-14.223-14.181Z",
    transform: "translate(-2859.401 -2626.999)",
    fill: "#82bb3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5365,5130.314c.271.49,7.208,7.15,8.287,8.38.439-.254,23.893-23.852,26.609-26.563a21.886,21.886,0,0,0,1.792-1.82,6.071,6.071,0,0,0-.957-1.067c-.372-.353-.686-.663-1.062-1.042-.712-.713-1.364-1.376-2.086-2.089-.438-.434-3.765-3.907-4.2-4.114a24.477,24.477,0,0,1-3.99,3.112c-5.577,3.342-9.146,1.42-14.5,6.743-3.4,3.4-3.508,5.163-4.692,9.442A18.392,18.392,0,0,1,5365,5130.314Z",
    transform: "translate(-5281.737 -5050.313)",
    fill: "#116e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2325,4148.563c.21.4,6.538,6.6,7.036,7.116l21.322,21.282,8.605-8.54a14.023,14.023,0,0,0-1.713-1.819c-.628-.621-1.192-1.186-1.8-1.793l-23.013-23.016c-.54-.541-1.317-1.229-1.773-1.794-.524.186-3.9,3.78-4.365,4.235-.751.731-1.42,1.425-2.15,2.153C2326.442,4147.081,2325.629,4147.828,2325,4148.563Z",
    transform: "translate(-2305.224 -4108.402)",
    fill: "#7b8994",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1378,5111.287l7.08,7.1c2.381,2.4,4.719,4.737,7.1,7.122l10.63,10.611c.5.494,3.279,3.351,3.591,3.545l8.249-8.273a18.131,18.131,0,0,0-1.753-1.794l-24.831-24.849a10.374,10.374,0,0,0-1.859-1.749c-.626.662-1.357,1.353-2.046,2.039l-4.092,4.1c-.376.377-.69.687-1.045,1.045A6.048,6.048,0,0,0,1378,5111.287Z",
    transform: "translate(-1378 -5051.297)",
    fill: "#7b8994",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3398,3656.71c.147.438.521.666.834.96l2.739,2.759c.521.522,3.359,3.443,3.7,3.633l10.481-10.464c.543.272,9.755,9.9,10.567,10.464l3.636-3.594a50.5,50.5,0,0,0,3.632-3.759c-.478-.332-14.7-14.684-16.646-16.622a4.243,4.243,0,0,0-1.229-1.089Z",
    transform: "translate(-3355.815 -3617.865)",
    fill: "#82bb3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1879,4662.16l28.4,28.425,7.12-7.163-28.4-28.422c-.479.358-1.3,1.271-1.774,1.731l-3.572,3.6A14.51,14.51,0,0,0,1879,4662.16Z",
    transform: "translate(-1868.538 -4612.652)",
    fill: "#7b8994",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4919,4683.359l7.1,7.147a14.57,14.57,0,0,0,3.115-4.017,22.739,22.739,0,0,0,1.773-5.3,17.44,17.44,0,0,1,3.4-7.271c3.18-3.753,5.706-5.658,10.781-6.931,3.3-.835,4.884-1.255,7.494-3.177a9.685,9.685,0,0,0,1.862-1.772l-7.082-7.038a18.87,18.87,0,0,0-1.9,1.608,17.929,17.929,0,0,1-7.142,3.53c-4.385,1.211-6.143,1.357-9.5,4.716a15.367,15.367,0,0,0-3.026,4.051,30.062,30.062,0,0,0-1.7,5.476A18.912,18.912,0,0,1,4919,4683.359Z",
    transform: "translate(-4845.052 -4612.652)",
    fill: "#116e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4406,4168.4l8.542,8.544a16.006,16.006,0,0,0,3.07-4.032c2.423-4.512,1.064-8.666,6.847-14.449,6.414-6.434,11.011-3.928,16.563-8.233a9.1,9.1,0,0,0,1.886-1.771,22.052,22.052,0,0,1-2.111-2.067l-5.328-5.328c-.353-.352-.731-.894-1.195-1.061-.6.749-13.447,13.467-14.134,14.16-4.471,4.468-9.167,9.274-13.706,13.691-.076.089-.139.13-.224.215C4406,4168.295,4406.1,4168.127,4406,4168.4Z",
    transform: "translate(-4342.761 -4108.402)",
    fill: "#116e99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3393,6176.168a22.59,22.59,0,0,0,3.343,3.144,24.022,24.022,0,0,0,29.07-.014c.332-.273.544-.443.859-.711a16.275,16.275,0,0,0,2.483-2.523l-7.06-7.065c-.4.1-.524.4-1.043.792a15.494,15.494,0,0,1-19.484.089l-1.066-.857c-1.193,1.148-2.345,2.337-3.528,3.53C3396.026,6173.1,3393.231,6175.789,3393,6176.168Z",
    transform: "translate(-3350.918 -6095.026)",
    fill: "#0fa9a6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3851,4552.358l8.313,8.347,8.375-8.322-8.356-8.382c-1.4,1.376-2.753,2.729-4.155,4.156Z",
    transform: "translate(-3799.354 -4503.965)",
    fill: "#82bb3a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3840,5663.688a5.522,5.522,0,0,1,.833.641,12.357,12.357,0,0,0,12.678,1.594c1.106-.482,3.153-1.7,3.589-2.487l-8.478-8.434a58.245,58.245,0,0,0-4.347,4.242l-3.758,3.732C3840.271,5663.257,3840.1,5663.293,3840,5663.688Z",
    transform: "translate(-3788.584 -5591.765)",
    fill: "#0fa9a6",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f558d214ecea6873f76cc18f9c79cab5.svg";
export { ForwardRef as ReactComponent };